import { render } from "./ProposalCreateSearch.vue?vue&type=template&id=76ca7a45"
import script from "./ProposalCreateSearch.vue?vue&type=script&lang=js"
export * from "./ProposalCreateSearch.vue?vue&type=script&lang=js"

import "./ProposalCreateSearch.vue?vue&type=style&index=0&id=76ca7a45&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__